/**
 * GridTextRow — `grid.text` renderer. Paints a short text string
 * inside the parent grid's day cell from the parent `(text, scalar)`
 * source's cells (a cell write is the SDK row's).
 */
import type { Option } from "../../core/option.ts";
import type { NaiveDate } from "@tento-chrono";

import { RendererRow } from "./renderer-row.ts";
import { SourceCells } from "./source-cells.ts";
import { SourceRow } from "./source-row.ts";

/**
 * The `grid.text` renderer row: paints its source row's text inside the month grid's day
 * cells.
 */
export class GridTextRow extends RendererRow {
  get source(): SourceRow {
    const p = this.parent;
    if (!(p instanceof SourceRow)) {
      throw new Error(
        `GridTextRow: parent of ${this.id.rawId} is not a SourceRow ` +
          `(got ${p?.constructor.name ?? "undefined"}).`,
      );
    }
    return p;
  }

  peekText(date: NaiveDate.Partial): Option<string> {
    const cell = SourceCells.dates(this.source.peekCells(date.toRange()))[0];
    return cell == null ? null : (cell.value as Option<string>);
  }
}
